import { getLocalWishlist, SELECTORS } from "./novicell_wishlist-utils";

if (!customElements.get('wishlist-page')) {
  class WishlistPage extends HTMLElement {
    constructor() {
      super();
      this.shareButton = document.querySelector('[data-wishlist-share]');
      this.toast = this.shareButton.querySelector('.wishlist-toast');
      this.shareButtonText = this.shareButton.querySelector('.wishlist-text');
      this.wishlistFromUrl = this.getWishlistFromUrl();
      console.log('wishlistFromUrl', this.wishlistFromUrl, location.href);
    }

    connectedCallback() {
      this.setupGrid();
      this.setupEventListeners();
    }

    setupEventListeners() {
      document.addEventListener('wishlist:updated', this.setupGrid.bind(this));
      this.shareButton.addEventListener('click', this.shareWishlist.bind(this));
    }

    shareWishlist(event) {
      event.preventDefault();
      const wishlist = getLocalWishlist();
      let url = window.location.href;
      if (wishlist.length) {
        const params = new URLSearchParams(location.search);
        params.set('wishlist', wishlist.join('+'));
        const base = window.location.origin + window.location.pathname;
        url = `${base}?${params.toString()}`;
      }
      navigator.clipboard.writeText(url);
      this.toast.classList.add('show');
      this.shareButtonText.style.display = 'none';
      this.toast.style.display = 'inline';
      
      setTimeout(() => {
        this.shareButtonText.style.display = 'inline';
        this.toast.style.display = 'none';
      }, 2000);
    }

    get wishlistGrid() {
      return this.querySelector(SELECTORS.WISHLIST_GRID);
    }

    get items() {
      return Array.from(this.querySelectorAll('[data-js-product-item] quick-buy'));
    }

    getWishlistFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const wishlistRaw = params.get('wishlist');
      const wishlistArr = wishlistRaw ? decodeURIComponent(wishlistRaw).split('+') : [];
      return wishlistArr;
    }

    async setupGrid() {
      if (!this.wishlistGrid) return;
      const wishlist = this.wishlistFromUrl.length ? this.wishlistFromUrl : getLocalWishlist();
      const requests = wishlist.map(this.fetchProductCardHTML);
      const responses = await Promise.all(requests);

      const wishlistProductCards = responses.join('');
      this.renderWishlistContent(wishlistProductCards);
    }

    renderWishlistContent(wishlistProductCards) {
      const wishlistEmpty = this.querySelector(SELECTORS.WISHLIST_EMPTY);
      const wishlistGridWrapper = this.querySelector(SELECTORS.WISHLIST_GRID_WRAPPER);

      if (wishlistProductCards) {
        if (wishlistEmpty) {
          wishlistEmpty.classList.add('is-hidden');
        }
        if (wishlistGridWrapper) {
          wishlistGridWrapper.classList.remove('is-hidden');
        }
        this.wishlistGrid.innerHTML = wishlistProductCards;
      } else {
        if (wishlistEmpty) {
          wishlistEmpty.classList.remove('is-hidden');
        }
        if (wishlistGridWrapper) {
          wishlistGridWrapper.classList.add('is-hidden');
        }
        this.wishlistGrid.innerHTML = '';
      }

      const event = new CustomEvent('wishlist:render-content', {});
      document.dispatchEvent(event);
    }

    async fetchProductCardHTML(handle) {
      const productTileTemplateUrl = `/products/${handle}?view=product-card`;

      try {
        const res = await fetch(productTileTemplateUrl);
        const res_2 = await res.text();
        const text = res_2;
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(text, 'text/html');

        const productCard = htmlDocument.documentElement.querySelector('.card-wrapper');
        let listElement = null;
        if (productCard) {
          listElement = document.createElement('li');
          listElement.classList.add('column');
          listElement.innerHTML = productCard.outerHTML;
        }

        if (listElement) return listElement.outerHTML;
      } catch (err) {
        return console.error(`[Wishlist] Failed to load content for handle: ${handle}`, err);
      }
    }
  }

  customElements.define('wishlist-page', WishlistPage);
}